import React, { useRef } from 'react';

import { Title } from 'src/application/components/ContentWrapper/Title/Title';
import { Fade } from 'src/application/components/transitions/Fade';
import { useIsMobileV2 } from 'src/application/hooks/useIsMobile';

import { GetAssetDataForIndex } from '../../../../hooks/useGetMultipleAssetUrls';
import { DisplayAsset, SlideWidgetBody } from '@ael/shared-components-library';

import './InteractiveWidgetBody.scss';

type InteractiveWidgetBodyProps = {
  title?: string;
  text?: string;
  assetData: ReturnType<GetAssetDataForIndex>;
  assetAlignment?: 'left' | 'under' | 'right' | null;
  inSmallWindow?: boolean;
};

export const InteractiveWidgetBody = (props: InteractiveWidgetBodyProps) => {
  const ref = useRef(null);

  const { title, text, assetAlignment } = props;

  const isMobile = useIsMobileV2();

  const isSmallScreen = isMobile || props.inSmallWindow;

  return (
    <Fade ref={ref}>
      <SlideWidgetBody
        ref={ref}
        title={<Title title={title} small />}
        text={
          text && (
            <div
              className="interactive-widget__body-inner-text uno-w-full"
              dangerouslySetInnerHTML={{ __html: text ?? '' }}
            />
          )
        }
        assetAlignment={isSmallScreen ? 'under' : assetAlignment}
        asset={
          props.assetData && (
            <DisplayAsset
              key={props.assetData.url}
              src={props.assetData.url}
              type={props.assetData.type}
              loaderHeight={props.assetData.dimensions?.height}
              loaderWidth={props.assetData.dimensions?.width}
              altTitle={title}
              maxImageHeight="large"
            />
          )
        }
        useCompactLayout={isSmallScreen}
      />
    </Fade>
  );
};
